<div class="d-flex align-items-center gap-2x">
  <button
    ds-button
    icon="download"
    ds-loading
    [isLoading]="loading()"
    (click)="onDownload()"
    variant="ghost"
    size="sm"
  ></button>
</div>
